var React = require('react');

function MTVResources (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"#4BACEC","d":"M106.475,109.699L73.23,52.571L39.984,109.7c-0.631,0.982-1.221,1.993-1.765,3.033l0,0.001h0\n\t\tc-2.862,5.468-4.489,11.685-4.489,18.284c0,21.815,17.685,39.5,39.5,39.5c21.815,0,39.5-17.685,39.5-39.5\n\t\tC112.73,123.162,110.427,115.85,106.475,109.699z","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M162.031,68.2L139.5,29.483l-22.532,38.718c-0.428,0.666-0.827,1.351-1.196,2.055l0,0h0\n\t\tc-1.94,3.706-3.042,7.919-3.042,12.392c0,14.785,11.985,26.77,26.77,26.77c14.785,0,26.77-11.986,26.77-26.77\n\t\tC166.27,77.325,164.71,72.369,162.031,68.2z","key":1})]));
}

MTVResources.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 200","enableBackground":"new 0 0 200 200","xmlSpace":"preserve"};

module.exports = MTVResources;

MTVResources.default = MTVResources;
